module.exports = __webpack_public_path__ + "img/thumb_19.dc2ed50f.jpg";